module.exports = __webpack_public_path__ + "static/media/jt-2021.52bef46d.png";